<template>
  <div class="modal">
    <div class="modal__header">
      <p v-if="subtitle" class="modal__action">
        {{ subtitle }}
      </p>
      <h2 v-if="title" class="modal__title">
        {{ title }}
      </h2>
      <div class="modal__header-action-wrapper">
        <slot name="header-action" />
      </div>
      <button class="modal__close-button" @click="handleClose">
        <CloseIcon class="close-button__icon" />
      </button>
    </div>
    <div v-if="tabs && tabs.length" class="modal__tabs spacex-8">
      <Tab
        v-for="tab in tabs"
        :key="tab.id"
        :title="tab.text"
        :selected="tab.id === currentTabId"
        @click.native="$emit('change-tab', tab.id)"
      />
    </div>
    <div class="modal__body">
      <slot />
    </div>
    <div v-if="$slots.footer" class="modal__footer">
      <div class="hr" />
      <div class="modal__navigation">
        <ProgressSteps
          v-if="currentStep"
          :current="currentStep"
          class="navigation__steps"
          :count="stepsCount"
        />

        <div class="navigation__buttons">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import CloseIcon from '@/assets/icons/x.svg';
  import ProgressSteps from '@/components/ui/ProgressSteps';
  import Tab from '@/components/tabs/Tab';

  export default {
    name: 'BaseModal',
    components: {
      Tab,
      CloseIcon,
      ProgressSteps,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        default: '',
      },
      currentStep: {
        type: Number,
        default: 0,
      },
      stepsCount: {
        type: Number,
        default: 0,
      },
      needCloseEmit: {
        type: Boolean,
        default: false,
      },
      tabs: {
        type: Array,
        required: false,
      },
      currentTabId: {
        type: Number,
        default: 1,
      },
    },
    methods: {
      ...mapActions({
        setModalAction: 'modal/setModalAction',
        close: 'modal/closeModal',
      }),
      handleClose() {
        if (this.needCloseEmit) {
          this.$emit('close');
        } else {
          let query = Object.assign({}, this.$route.query);
          if (query.modal) {
            delete query.modal;
            this.$router.replace({ query });
          }
          this.close();
        }
      },
    },
  };
</script>
